import { useQuery } from "@apollo/client/react";

import { workforceGuardrailInbox } from "./workforceGuardrailInbox.graphql";

type WaitingQuery = {
  workforceGuardrailQueue?: { waitingCount?: number | null } | null;
};

/** Sidebar badge. Same query as the page, so a write refetch updates both. */
export const useInboxWaitingCount = (enabled: boolean): number => {
  const { data } = useQuery<WaitingQuery>(workforceGuardrailInbox, {
    skip: !enabled,
  });
  return data?.workforceGuardrailQueue?.waitingCount ?? 0;
};
